const addOrderGroupDataToLinkedOrder = (order, linkedOrder) => {
  return {
    ...linkedOrder,
    vehicleType: order?.vehicleType,
  };
};

export default addOrderGroupDataToLinkedOrder;
